<template>
  <div class="autocomplete">
    <div class="form-group row">
      <div class="col-md-12">
        <mdc-textfield :id=id
                       autocomplete="off"
                       :name=id
                       type="text"
                       :ref=id
                       :multiline=multiline
                       :rows="rowsCount"
                       v-model="inputText"
                       :label="label"
                       :class="{'is-invalid': errors.has(id)}"
                       :disabled="disabled"
                       class="autocomplete__input"
                       @keydown.enter='enter'
                       @keydown.down='down'
                       @keydown.right='right'
                       @keydown.up='up'
                       @input='change'
                       @blur="hideDropdown"
                       @validate="validate"
                       v-validate="validateRule"
                       data-vv-validate-on="none"
                       :data-vv-as="validateLable"/>

        <span class="invalid-feedback"
              v-if="errors.has(id)">
             <strong>{{ errors.first(id) }}</strong>
           </span>

      </div>
    </div>


    <ul class="autocomplete-dropdown"
        :class="{'open':openSuggestion}"
        ref="scrollContainer">
      <li class="autocomplete-dropdown__item"
          ref="options"
          v-for="(item, index) in suggestions"
          :class="{'active': isActive(index)}"
          @click="suggestionClick(index, item[field])"
          @keydown.enter="suggestionClick(index, item[field])">
        {{ item[field] }}
      </li>
    </ul>
  </div>
</template>
<script>
  import debounce from 'lodash/debounce';

  export default {
    props: {
      'field': {
        required: true,
        type: String,
        default() {
          return 'text';
        },
      },
      'label': {
        required: true,
        type: String,
        default() {
          return '';
        },
      },
      'id': {
        type: String,
        default() {
          return 'text';
        },
      },
      'validateLable': {
        required: true,
        type: String,
        default() {
          return '';
        },
      },
      'validateRule': {
        required: true,
        type: String,
        default() {
          return '';
        },
      },
      'visible': {
        required: true,
        type: Boolean,
        default() {
          return false;
        },
      },
      'disabled': {
        required: false,
        type: Boolean,
        default() {
          return false;
        },
      },
      suggestions: {
        type: Array,
        required: true,
        default() {
          return null;
        },
      },
      value: {
        type: [String, Number],
      },
      rowsCount: {
        required: false,
        type: [String, Number],
        default() {
          return 1;
        },
      },
      multiline: {
        required: false,
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        open: false,
        current: -1,
      }
    },

    inject: ["parentValidator"],

    created() {
      this.$validator = this.parentValidator;
    },

    computed: {
      openSuggestion() {
        return this.suggestions.length > 0 && this.open === true;
      },
      inputText: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        }
      }
    },
    methods: {
      blockCarret(event) {
        if (event.keyCode == '38' || event.keyCode == '40') {
          event.preventDefault();
        }
      },
      reset() {
        Object.assign(this.$data, this.$options.data());
        this.errors.clear();
      },
      async validate() {
        let result = await this.$validator.validateAll();
        if (result) {
          document.removeEventListener('keydown', this.blockCarret);
          this.$emit('save', this.inputText);
        } else{
          this.$emit('validate', this.errors);
        }
      },
      enter() {
        if (this.current > -1 && this.current < this.suggestions.length) {
          this.suggestionClick(this.current, this.suggestions[this.current][this.field])
        }
        //this.open = false;
        //this.validate();
      },
      right() {
        if (this.current !== -1) {
          this.inputText = this.suggestions[this.current][this.field]
          this.change();
        }
      },
      up() {
        if (this.current > -1) {
          this.current--;
        }
        else {
          this.current = this.suggestions.length - 1
        }

        this.fixScrolling();
      },
      down() {
        if (this.current < this.suggestions.length - 1) {
          this.current++;
        }
        else {
          this.current = -1;
        }

        this.fixScrolling();
      },
      fixScrolling(){
        if (this.current >= 0) {
          let liHeight = this.$refs.options[this.current].clientHeight;
          this.$refs.scrollContainer.scrollTop = liHeight * this.current;
        }
      },
      hideDropdown(){
        let self = this;

        setTimeout(function () {
          self.open = false;
        }, 200);
      },
      isActive(index) {
        return index === this.current;
      },
      change: debounce(function () {
        if (this.inputText.length > 0) {
          this.$emit('inputChange', this.inputText);

          if (this.open == false) {
            this.open = true;
            this.current = -1;
          }
        }
      }, 100),
      suggestionClick(index, text) {
        this.current = index;
        this.inputText = text;
        this.$emit('inputChange', this.inputText);
        this.open = false;
      },
    },
    watch: {
      visible() {
        if (this.visible) {
          document.addEventListener('keydown', this.blockCarret);
        }
        else {
          document.removeEventListener('keydown', this.blockCarret);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/autocompleteSearch/components/autocompleteSearch.vue